import type { StaticSlice } from "@prismicio/types-internal/lib/customtypes"

interface GetFieldsetArgs {
  config: StaticSlice
}

export function getFieldset(args: GetFieldsetArgs) {
  const { config } = args
  return "fieldset" in config && config.fieldset ? config.fieldset : undefined
}
